<ng-container *transloco="let t; read: 'devices.detail'">
  <ng-container *transloco="let tGlobal; read: 'global'">
    @if (vm$ | async; as vm) {
      <div class="componentContainer">
        <section class="xs12col componentHeader">
          <h1>{{t('title')}}</h1>
        </section>
        <kendo-tabstrip>
          <kendo-tabstrip-tab title="{{ t('tab.general') }}" [selected]="true">
            <ng-template kendoTabContent>
              <section class="oneCol">
                <div class="xs12col">
                  <form [formGroup]="deviceForm" class="flexColumn">
                    <div class="fieldsetWrapper flexRow">
                      <div class="xs12col m4col align-top">
                        <fieldset class="fieldsetContainer ">
                          <h2 class="padding-bottom-small">{{ t('company') }}</h2>
                          <kendo-formfield [hidden]="!('Permissions.Devices.Update' | permission)">
                            <kendo-label [text]="t('company')">*</kendo-label>
                            <kendo-dropdownlist
                              [data]="vm.companies"
                              textField="name"
                              valueField="id"
                              [defaultItem]="{ id: null, name: 'Kunde wählen' }"
                              formControlName="companyId"
                              [valuePrimitive]="true"
                              (valueChange)="onCompanyChange($event)">
                            </kendo-dropdownlist>
                          </kendo-formfield>
                          <kendo-formfield>
                            <kendo-label [text]="t('deviceLocation')"></kendo-label>
                            <kendo-dropdownlist
                              [data]="vm.deviceLocations"
                              textField="name"
                              valueField="id"
                              [defaultItem]="{ id: null, name: t('chooseLocation') }"
                              formControlName ="deviceLocationId"
                              [valuePrimitive]="true">
                            </kendo-dropdownlist>
                          </kendo-formfield>
                          @if (vm.device) {
                            <div class="flexColumn">
                              <span class="fontBold padding-bottom-small">{{ t('installation') }}</span>
                              @if (vm.device.installation) {
                                <a [href]="baseUrl + vm.device.installation.id">{{ vm.device.installation.name }}</a>
                              } @else {
                                <span>{{ t('noInstallation') }}</span>
                              }
                            </div>
                          }
                        </fieldset>
                      </div>
                      <div class="xs12col m4col align-top">
                        <fieldset class="fieldsetContainer">
                          <h2 class="padding-bottom-small">{{ t('status') }}</h2>
                          <kendo-formfield>
                            <kendo-label [text]="t('deviceStatus')"></kendo-label>
                            <kendo-dropdownlist
                              [data]="deviceStatus"
                              [itemDisabled]="itemDisabled"
                              textField="name"
                              valueField="id"
                              formControlName="deviceStatus"
                              [readonly]="isNew"
                              [valuePrimitive]="true">
                            </kendo-dropdownlist>
                          </kendo-formfield>
                          <kendo-formfield>
                            <kendo-label [text]="t('devicePriority')"></kendo-label>
                            <kendo-dropdownlist
                              [data]="devicePriority"
                              textField="name"
                              valueField="id"
                              [defaultItem]="{ id: null, name: t('choosePriority') }"
                              formControlName="devicePriority"
                              [valuePrimitive]="true">
                            </kendo-dropdownlist>
                          </kendo-formfield>
                        </fieldset>
                      </div>
                      <div class="xs12col m4col align-top">
                        <fieldset class="fieldsetContainer">
                          <h2 class="padding-bottom-small">{{ t('maintenance') }}</h2>
                          <kendo-formfield>
                            <kendo-label text="{{ t('deliveryDate') }}"></kendo-label>
                            <kendo-datepicker
                              formControlName="deliveryDate"
                              [placeholder]="t('deliveryDatePlaceholder')"
                            ></kendo-datepicker>
                          </kendo-formfield>
                          <kendo-formfield>
                            <span  class="tooltipContainer">
                              <kendo-label [text]="t('maintenanceInterval')">
                                <span [attr.tooltip]="t('tooltipMaintenanceInterval')" flow="right" class="tooltipContainer">
                                  <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
                                </span>
                              </kendo-label>

                            </span>
                            <kendo-numerictextbox
                              formControlName="maintenanceInterval"
                              [format]="'n0'"
                              [readonly]="false"
                            ></kendo-numerictextbox>
                          </kendo-formfield>
                        </fieldset>
                      </div>
                      <div class="xs12col align-bottom flex-wrap">
                        <div class="xs12col m4col">
                          <fieldset class="fieldsetContainer flexColumn">
                            <h2 class="xs12col padding-bottom-small">{{ t('device') }}</h2>
                            <kendo-formfield>
                              <kendo-label [text]="t('manufacturer')">*</kendo-label>
                              <kendo-dropdownlist
                                [data]="vm.deviceManufacturers"
                                textField="name"
                                valueField="id"
                                [defaultItem]="{ id: null, name: 'Hersteller wählen' }"
                                formControlName="deviceManufacturerId"
                                [valuePrimitive]="true">
                              </kendo-dropdownlist>
                            </kendo-formfield>
                            <kendo-formfield>
                              <kendo-label [text]="t('deviceCategory')">*</kendo-label>
                              <kendo-dropdownlist
                                [data]="vm.deviceCateogries"
                                textField="name"
                                valueField="id"
                                [defaultItem]="{ id: null, name: 'Kategorie wählen' }"
                                formControlName ="deviceCategory"
                                [valuePrimitive]="false">
                              </kendo-dropdownlist>
                            </kendo-formfield>
                            <kendo-formfield>
                              <kendo-label [text]="t('serialNumber')">
                                @if (deviceForm.get('deviceCategory').value?.hasSerialNumber) {
                                  <span class="required-marker">*</span>
                                }
                              </kendo-label>
                              <kendo-textbox
                                formControlName="serialNumber"
                              ></kendo-textbox>
                              @if (deviceForm.get('serialNumber')?.hasError('serialNumberRequired')) {
                                <span class="error-text">{{ t('validation.serialNumberRequired') }}</span>
                              }
                              @if (deviceForm.get('serialNumber')?.hasError('serialNumberExists')) {
                                <span class="error-text">{{ t('validation.serialNumberExists') }}</span>
                              }
                            </kendo-formfield>
                          </fieldset>
                        </div>
                        <div class="xs12col m4col">
                          <fieldset class="fieldsetContainer flexRow">
                            <kendo-formfield>
                              <kendo-label [text]="t('importantNote')"></kendo-label>
                              <kendo-textbox
                                formControlName="importantNote"
                              ></kendo-textbox>
                            </kendo-formfield>
                            <kendo-formfield>
                              <kendo-label [text]="t('type')"></kendo-label>
                              <kendo-textbox
                                formControlName="type"
                              ></kendo-textbox>
                            </kendo-formfield>
                            <kendo-formfield>
                              <kendo-label [text]="t('sequenceNumber')"></kendo-label>
                              <kendo-textbox
                                formControlName="sequenceNumber"
                                [readonly]="true"
                              ></kendo-textbox>
                            </kendo-formfield>
                          </fieldset>
                        </div>
                        <div class="xs12col m4col">
                          <fieldset class="fieldsetContainer flexRow">
                            <kendo-formfield>
                              <kendo-label [text]="t('equipmentNumber')"></kendo-label>
                              <kendo-textbox
                                formControlName="equipmentNumber"
                              ></kendo-textbox>
                              @if (deviceForm.get('equipmentNumber')?.hasError('equipmentNumberExists')) {
                                <span class="error-text">{{ t('validation.equipmentNumberExists') }}</span>
                              }
                            </kendo-formfield>
                            <kendo-formfield>
                              <kendo-label [text]="t('tagNumber')"></kendo-label>
                              <kendo-textbox
                                formControlName="tagNumber"
                              ></kendo-textbox>
                            </kendo-formfield>
                            <kendo-formfield>
                              <kendo-label [text]="t('qrNumber')"></kendo-label>
                              <kendo-textbox
                                formControlName="qrNumber"
                              ></kendo-textbox>
                            </kendo-formfield>
                          </fieldset>
                        </div>
                        <div class="xs12col m4col">
                          <fieldset class="fieldsetContainer flexRow">
                            <div class="buttonContainer">
                              <button
                                kendoButton
                                class="buttonPrimary"
                                type="submit"
                                (click)="saveChanges(vm.device?.id, vm.revisionId)"
                                [hidden]="!('Permissions.Devices.Update' | permission)"
                                [disabled]="deviceForm?.invalid || !deviceForm?.dirty">
                                {{ isNew ? t('submit') : t('save') }}
                              </button>
                            </div>
                          </fieldset>
                        </div>
                      </div>
                    </div>

                    <button
                      type="delete"
                      (click)="deletionDialogOpen(vm.device?.id)"
                      class="buttonSecondary delete padding-top-medium padding-bottom-medium"
                      [hidden]="isNew || !('Permissions.Devices.Delete' | permission)">
                      {{ tGlobal('delete') }}
                    </button>
                  </form>
                </div>
              </section>
            </ng-template>
          </kendo-tabstrip-tab>
          <kendo-tabstrip-tab title="{{ t('tab.wearingParts') }}" [disabled]="isNew">
            <ng-template kendoTabContent>
              <app-device-detail-wearing-parts
                class="xs12col"
                [isAdmin]="isAdmin"
                [companyOnDevice]="vm.device?.company?.id"
              [hidden]="isNew"></app-device-detail-wearing-parts>
            </ng-template>
          </kendo-tabstrip-tab>
          <kendo-tabstrip-tab title="{{ t('tab.services') }}" [disabled]="isNew || !('Permissions.Services.Search' | permission)">
            <ng-template kendoTabContent>
              <app-device-detail-services class="xs12col" [deviceId]="vm.device?.id" [isAdmin]="isAdmin" [hidden]="isNew || !('Permissions.Services.Search' | permission)"></app-device-detail-services>
            </ng-template>
          </kendo-tabstrip-tab>
          <kendo-tabstrip-tab title="{{ t('tab.notes') }}" [disabled]="isNew || !('Permissions.Notes.Search' | permission)">
            <ng-template kendoTabContent>
              <app-device-detail-notes class="xs12col" [deviceId]="vm.device?.id" [isAdmin]="isAdmin" [hidden]="isNew || !('Permissions.Notes.Search' | permission)"></app-device-detail-notes>
            </ng-template>
          </kendo-tabstrip-tab>
          <kendo-tabstrip-tab title="{{ t('tab.documents') }}" [disabled]="isNew || !('Permissions.Attachments.View' | permission)">
            <ng-template kendoTabContent>
              <app-device-detail-attachments class="xs12col" [deviceId]="vm.device?.id" [isAdmin]="isAdmin" [hidden]="isNew || !('Permissions.Attachments.View' | permission)"></app-device-detail-attachments>
            </ng-template>
          </kendo-tabstrip-tab>
        </kendo-tabstrip>
        @if (vm.deviceIdToDelete != null && deletionDialogOpened) {
          <kendo-dialog
            title="{{t('confirmDeletion')}}"
            (close)="deletionDialogClose('cancel', vm.deviceIdToDelete)"
            [minWidth]="250"
            [width]="450">
            <p style="margin: 30px; text-align: center;">
              {{t('deletionMessage')}}
            </p>
            <kendo-dialog-actions>
              <button kendoButton (click)="deletionDialogClose('cancel', vm.deviceIdToDelete)">{{ t('cancel') }}</button>
              <button kendoButton (click)="deletionDialogClose('delete', vm.deviceIdToDelete)" themeColor="primary">{{ t('delete') }}
              </button>
            </kendo-dialog-actions>
          </kendo-dialog>
        }
      </div>
    }
  </ng-container>
</ng-container>